import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi everyone! I’m <span className="purple">Challa Praveen Kumar</span>{" "}
            from <span className="purple">Andhra Pradesh, India</span>.
            <br />
            <br>
            </br>
            <span>
              “I’m currently looking for opportunities as a Software Developer.
            </span>
            
           
{" "} “I’m actively seeking entry-level opportunities in Software Development.
            {/* <span className="purple">Software Developer</span> at{" "} */}
            {/* <span className="purple">Juspay</span>. */}
            <br />I hold an Integrated MCA.  in{" "}
            <span className="purple">Master Of Computer Applications</span> from{" "}
            <span className="purple">gayatri vidya parishad degree and pg college</span>.
            <br />
            <br />
            Outside of coding, I love engaging in activities that keep me
            creative and inspired:
          </p>

          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games 🎮
            </li>
            <li className="about-activity">
              <ImPointRight /> Writing Tech Blogs ✍️
            </li>
            <li className="about-activity">
              <ImPointRight /> Traveling and Exploring New Places 🌍
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Challa Praveen Kumar</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
